import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

const CuentaContableHastaFormGroup = ({ iTouched, iError, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label
        text='CUENTA HASTA'
        htmlFor='input-cuentaContableHasta'
        md={4}
        alignRightAt='md'
      />
      <Col md={8}>
        <Field name='cuentaContableHasta'>
          {({ field }) => (
            <Form.InputText
              {...field}
              id='input-cuentaContableHasta'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContableHastaFormGroup)
